import { StringUtil } from '@nomidio/common';

export enum RealmType {
  Idaas = 'IDAAS',
  Enterprise = 'ENTERPRISE',
}

export function RealmTypePresentation(realmType: RealmType): string {
  switch (realmType) {
    case RealmType.Idaas:
      return 'IDaaS';
    case RealmType.Enterprise:
      return 'Enterprise';
    default:
      console.warn(`Mapping not handled for type '${realmType}' falling back to value`);
      return StringUtil.toPresentationFormat(realmType);
  }
}
